module.exports = __webpack_public_path__ + "static/media/astrid_sweedish.c1e13328.mp3";